import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';
import { MenuService } from 'src/app/services/menu.service'; // ← where getWeeklyTodo lives
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { BtcPriceTrackerComponent } from '../btc-price-tracker/btc-price-tracker.component';

@Component({
  selector: 'app-user-dashboard',
  templateUrl: './user-dashboard.component.html',
  styleUrls: ['./user-dashboard.component.css']
})
export class UserDashboardComponent implements OnInit {
  @ViewChild(BtcPriceTrackerComponent) cryptoTicker!: BtcPriceTrackerComponent;
  userRole:any = null;
  prioritiesText: SafeHtml = ''; // ← bind to the textarea
  accountInfoText: SafeHtml = ''; // ← bind to the textarea
  constructor(
    private router: Router,
    private authService: AuthService,
    private menuSvc: MenuService,
    private sanitizer: DomSanitizer
  ) { }

  ngOnInit(): void {
    setTimeout(() => {
      this.getPriorities();
    },500)
  }

  getPriorities(): void {
    const token = (JSON.parse(sessionStorage.getItem('wOSUser') || 'null')?.stsTokenManager?.accessToken) || '';
    this.userRole = sessionStorage.getItem('wOSUserRole') || '';

    this.menuSvc.getWeeklyTodo(token).subscribe(res => {
      this.prioritiesText = this.getSafeHTML((res?.txt_nextweek === null) ? 'No Priorities Available' : '<ul><li>' + res?.txt_nextweek + '</li></ul>');
    });

    this.menuSvc.getAccountAccess(token).subscribe(res => {
      this.accountInfoText = this.getSafeHTML((res?.txt_nextweek === null) ? 'No Account Info Available' : '<ul><li>' + res?.txt_nextweek + '</li></ul>');
    });
  }

  getSafeHTML(content: string): SafeHtml {
    const ret = this.sanitizer.bypassSecurityTrustHtml(content.replace(/\n/g,"</li><li>"));
    return ret;
  }

  goRoute(route: string): void {
    this.router.navigate([route]);
  }
}
